import { stepTypes } from '../../../constants/data-types';
import formatSectionErrors from '../../../helpers/formatSectionErrors';
import StepSection from './StepSection';

const DefaultStepSections = ({ state, setState, validationErrs, ...props }) => {
  const {
    thingsYouWillNeed,
    thingsThatMightBeUseful,
    whatHappensInThisStage,
    whatWillHappenNext,
    resources,
  } = state;

  const handleItemChange = (sectionKey, index, input) => {
    setState({
      [sectionKey]: state[sectionKey].map((element, i) =>
        i === index ? input : element
      ),
    });
  };

  const handleItemRemove = (sectionKey, index) => {
    setState({
      [sectionKey]: state[sectionKey].filter((_, i) => i !== index),
    });
  };

  const handleItemAdd = (sectionKey) => {
    const newItem = {
      title: '',
      description: [],
      thisCanInclude: [],
      tips: [],
    };

    setState({
      [sectionKey]: [...state[sectionKey], newItem],
    });
  };

  const sections = [
    {
      sectionItems: thingsYouWillNeed,
      sectionTitle: 'Things you will need',
      sectionKey: 'thingsYouWillNeed',
      errors: formatSectionErrors(
        'thingsYouWillNeed',
        validationErrs,
        stepTypes.DEFAULT
      ),
    },
    {
      sectionItems: thingsThatMightBeUseful,
      sectionTitle: 'Things that might be useful',
      sectionKey: 'thingsThatMightBeUseful',
      errors: formatSectionErrors(
        'thingsThatMightBeUseful',
        validationErrs,
        stepTypes.DEFAULT
      ),
    },
    {
      sectionItems: whatHappensInThisStage,
      sectionTitle: 'What happens in this stage',
      sectionKey: 'whatHappensInThisStage',
      errors: formatSectionErrors(
        'whatHappensInThisStage',
        validationErrs,
        stepTypes.DEFAULT
      ),
    },
    {
      sectionItems: whatWillHappenNext,
      sectionTitle: 'What will happen next',
      sectionKey: 'whatWillHappenNext',
      errors: formatSectionErrors(
        'whatWillHappenNext',
        validationErrs,
        stepTypes.DEFAULT
      ),
    },
    {
      sectionItems: resources,
      sectionTitle: 'Resources',
      sectionKey: 'resources',
      errors: formatSectionErrors(
        'resources',
        validationErrs,
        stepTypes.DEFAULT
      ),
      isResourcesLayout: true,
    },
  ];

  return (
    <>
      {sections.map((section) => (
        <StepSection
          key={`DEFAULT_SECTION_${section.sectionKey}`}
          {...section}
          {...props}
          stepType={stepTypes.DEFAULT}
          handleItemChange={(index, newValue) =>
            handleItemChange(section.sectionKey, index, newValue)
          }
          handleItemRemove={(index) =>
            handleItemRemove(section.sectionKey, index)
          }
          handleItemAdd={() => handleItemAdd(section.sectionKey)}
        />
      ))}
    </>
  );
};

export default DefaultStepSections;
